import { Box, BoxProps, Typography, styled } from '@mui/material';
import i18n from 'i18n';

import { flexMixin } from 'utils/flexMixin';

import { regularTextColor } from 'assets/styles/_palette';

interface BoxExtendedProps extends BoxProps {
	isStoryOpen?: boolean;
}

export const DropdownHeader = styled(Box, {
	shouldForwardProp: (prop) => prop !== 'isStoryOpen',
})<BoxExtendedProps>(({ isStoryOpen }) => ({
	...flexMixin({ justify: 'space-between', align: 'center' }),
	width: '100%',
	gap: '12px',
	cursor: 'pointer',
	position: 'relative',

	'& svg': {
		height: '12px',
		width: '12px',
		transition: '0.3s',
		transform:
			i18n.language === 'ar'
				? isStoryOpen
					? 'unset'
					: 'rotate(180deg)'
				: isStoryOpen
				? 'unset'
				: 'rotate(-180deg)',
	},

	'& > p': {
		width: '95%',
	},

	'&:after': {
		bottom: 0,
		content: '""',
		display: 'block',
		height: '1px',
		position: 'absolute',
		background: 'rgba(0, 0, 0, 0.26)',
		transition: 'width 0.3s ease 0s, left 0.3s ease 0s',
	},
}));

export const DropdownTitle = styled(Typography)({
	lineHeight: '24px',
	letterSpacing: '0.15px',
	wordWrap: 'break-word',
	whiteSpace: 'pre-line',
	color: regularTextColor,
});

export const DropdownArrow = styled(Box)({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: '24px',
	height: '24px',
	backgroundColor: '#ECF3FF',
	borderRadius: '24px',
});
